import React from "react";
import Rows from "components/Rows";
import { Form, Input } from "antd";
import RenFeiSelect from "components/RenFeiSelect";
import InputTextArea from "components/InputTextArea";
import UploadAvatar from "../components/UploadAvatar";
import StepHeader from "./StepHeader";

import { CONSTANTS_WEBSITE } from "../constants";

import type { LabelTooltipType } from "antd/es/form/FormItemLabel";

export interface TypePersonalInfoProps {
  /**
   * @param title 标题
   */
  title?: string;
  /**
   * @param badge 标题旁徽章，例如跨组织初始化时的 “New Personal site”
   */
  badge?: string;
  /**
   * @param intro 标题下说明
   */
  intro?: string;
  /**
   * @param auditTips 重新审核提示
   * @description 部分字段重新编辑会导致重新审核，是否提醒用户
   */
  auditTips?: LabelTooltipType;
}

type TypePersonalInfoComp = React.FC<TypePersonalInfoProps> & {
  REQUIRED: typeof FORM_REQUIRED_FIELDS;
};

const TEXT_AUTO_GENRATER = [
  `I am a dedicated Loan Officer with over 10 years of experience. I specialize in helping first-time homebuyers navigate the mortgage landscape. My mission is to provide clear, straightforward advice so you can make informed decisions. Let's turn your dream home into a reality!`,
  `With a passion for financial education and a knack for numbers, I've helped countless clients secure loans that fit their needs and lifestyle. I believe in a personalized, no-stress approach to lending. Reach out, and let's find the perfect loan for you!`,
  `Whether you are considering refinancing your current mortgage or are in the process of purchasing a new property, I am committed to providing unparalleled service and guidance from start to finish. Let us commence this financial journey together.`,
  `A certified Loan Officer with a keen focus on client financial education. I have successfully facilitated loans for a diverse clientele and take a bespoke approach to meet individual needs with minimal stress. I invite you to reach out for a customized loan solution tailored to your financial circumstances`,
];

// 必填的字段
export const FORM_REQUIRED_FIELDS = {
  Image: ["Image"],
  LastName: ["LastName"],
  FirstName: ["FirstName"],
};

/**
 * @name PersonalInfo 个人信息
 */
const PersonalInfo: TypePersonalInfoComp = ({
  auditTips,
  badge,
  intro,
  title = "Tell us about yourself",
}) => (
  <div className="layout-profile-ctx">
    <StepHeader title={title} badge={badge} intro={intro} />

    <Form.Item
      label="Profile photo"
      name={FORM_REQUIRED_FIELDS.Image}
      rules={[{ required: true, message: "Profile photo is required!" }]}
    >
      <UploadAvatar />
    </Form.Item>

    <Rows span={12}>
      <Form.Item
        label="First name"
        name={FORM_REQUIRED_FIELDS.FirstName}
        rules={[
          { required: true, message: "First name is required!" },
          { max: 25, message: "Limited to 25 characters" },
          {
            pattern: /^[a-zA-Z]+( [a-zA-Z]+)*$/,
            message:
              "English letters only. Single internal spaces allowed; no leading, trailing, or consecutive spaces.",
          },
        ]}
      >
        <Input placeholder="Please enter first name" />
      </Form.Item>

      <Form.Item
        label="Last name"
        tooltip={auditTips}
        name={FORM_REQUIRED_FIELDS.LastName}
        rules={[
          { required: true, message: "Last name is required!" },
          { max: 25, message: "Limited to 25 characters" },
          {
            pattern: /^[a-zA-Z]+( [a-zA-Z]+)*$/,
            message:
              "English letters only. Single internal spaces allowed; no leading, trailing, or consecutive spaces.",
          },
        ]}
      >
        <Input placeholder="Please enter last name" />
      </Form.Item>
    </Rows>

    <Form.Item label="Language" name={["LandingPageSetUp", "Languages"]}>
      <RenFeiSelect
        placeholder="Please select language"
        options={CONSTANTS_WEBSITE.LANG}
      />
    </Form.Item>

    <Form.Item
      name="Introduction"
      label="Professional Bio"
      // rules={[{ required: true, message: "Bio is required!" }]}
    >
      <InputTextArea texts={TEXT_AUTO_GENRATER} />
    </Form.Item>
  </div>
);

PersonalInfo.REQUIRED = FORM_REQUIRED_FIELDS;

export default PersonalInfo;
